const CONFIG_PROVIDER_LOCALE_INJECTION_KEY = Symbol("CONFIG_PROVIDER_LOCALE_INJECTION_KEY"), CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY = Symbol("CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY"), CONFIG_PROVIDER_DIRECTION_INJECT_KEY = Symbol("CONFIG_PROVIDER_DIRECTION_INJECT_KEY");
export {
  CONFIG_PROVIDER_DIRECTION_INJECT_KEY,
  CONFIG_PROVIDER_LOCALE_INJECTION_KEY,
  CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY
};
//# sourceMappingURL=injectionKeys.js.map
